import React from "react";
import Layout from "@/components/layout";
import HeaderOne from "@/components/header-one";
import MenuContextProvider from "@/context/menu-context";
import PageHeader from "@/components/page-header";
import Footer from "@/components/footer";
import AboutFour from "@/components/about-four";
import VideoOne from "@/components/video-one";
import TestimonialsOne from "@/components/testimonials-one";
import AboutTwo from "@/components/about-two";

const About = () => {
  return (
    <MenuContextProvider>
      <Layout PageTitle="O nama">
        <HeaderOne />
        <PageHeader title="O Nama" name="About" />
        <AboutFour />
        <VideoOne />
        <AboutTwo />
        <TestimonialsOne />
        {/* <TeamOne extraClassName="section_border" /> */}
        <Footer />
      </Layout>
    </MenuContextProvider>
  );
};

export default About;
